export default __webpack_public_path__ + "static/media/12.40d0ea78.PNG";